import { render } from "./portal-navigation.vue?vue&type=template&id=5d531247"
import script from "./portal-navigation.vue?vue&type=script&lang=js"
export * from "./portal-navigation.vue?vue&type=script&lang=js"

import "./portal-navigation.vue?vue&type=style&index=0&id=5d531247&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__